import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {
  Container, Row, Col, Card, CardBody, Spinner,
  Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, FormFeedback, Label, Input, Button,
} from 'reactstrap'
import { MaterialReactTable } from 'material-react-table'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Edit from '@material-ui/icons/Edit'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import qs from 'qs'
import Select from '../../../components/Template/Input/Select'
import DataTable from '../../../components/Template/Table/DataTable'
import { listOpProjects, listProjects } from '../../../store/ducks/technicalDep'
import oikosApi from '../../../services/oikos'
import powerAppsApi from '../../../services/powerapps/index'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import { notifyError, notifySuccess } from '../../../utils/notify'
import { history } from '../../../store'
import moment from 'moment'
import { graphClient } from '../../../store/sagas/auth'
import ModalFormulario from '../../../components/Modals/ModalFormulario/ModalFormulario'
import AsyncSelect from '../../../components/Template/Input/AsyncSelect'
import { update } from '../../../utils/fc'

class Projects extends Component {
  constructor(props) {
    super(props)
    this.state = {
      getLegalPeopleIsLoading: false,
      legalPeople: [],

      stakeholders: [],

      getProjectsToStartIsLoading: false,
      projectsToStart: [],

      pfs: [],

      openProjectModalIsOpen: false,
      openProjectIsLoading: false,
      openProjectData: {},

      isOpenModalNovaPesquisa: false,
      isModalOpenningLoading: false,
      perguntas: [],
      selPfs: [],
      defaultInputs: {},
    }
  }

  async componentDidMount() {
    const { listProjects, listOpProjects } = this.props

    listProjects(this.props.auth.user)
    listOpProjects()
    this.getLegalPeople()
    this.getProjectsToStart()

    const getOikosId = async (mail) => {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pf',
        data: {
          pf_emailProf: mail
        },
        fields: {
        }
      })}`)

      this.setState({ pfs: res.data[0].pf_id, userCargo: res.data[0].pf_cargo })
    }

    getOikosId(this.props.auth.user.mail);
  }

  getLegalPeople = async () => {
    this.setState({ getLegalPeopleIsLoading: true })

    try {
      const res = await oikosApi.get('/', {
        table: 'pj',
        action: 'get',
      })
      console.tron.log('res getLegalPeople', res)

      if (res.data) {
        this.setState({ getLegalPeopleIsLoading: false, legalPeople: res.data })
      } else {
        this.setState({ getLegalPeopleIsLoading: false, legalPeople: [] })
        notifyError('Não foi possível carregar Pessoas Jurídicas.')
      }
    } catch (e) {
      this.setState({ getLegalPeopleIsLoading: false, legalPeople: [] })
      notifyError('Não foi possível carregar Pessoas Jurídicas.')
    }
  }

  getProjectsToStart = async () => {
    this.setState({ getProjectsToStartIsLoading: true })

    try {
      /* await fetch('https://oikos.ecoss.is/oikos/_webhook_checknewcontracts.php')
      */
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contrato',
        data: {
          '(SELECT COUNT(*) FROM proj WHERE proj.contrato_id = contrato.contrato_id)': 0,
          contrato_ativo: 1,
        },
      })}`)
      console.tron.log('res getProjectsToStart', res)


      if (res.data) {
        this.setState({ getProjectsToStartIsLoading: false, projectsToStart: res.data })
      } else {
        this.setState({ getProjectsToStartIsLoading: false, projectsToStart: [] })
        notifyError('Não foi possível carregar Projetos a Iniciar.')
      }
    } catch (e) {
      this.setState({ getProjectsToStartIsLoading: false, projectsToStart: [] })
      notifyError('Não foi possível carregar Projetos a Iniciar.')
    }
  }

  handleOpenProjectSubmit = async () => {
    const { openProjectData } = this.state
    console.log('contrato a abrir', openProjectData)

    const formDataAbrirProjeto = new FormData()
    formDataAbrirProjeto.append('acao', 'abrir_projeto')
    formDataAbrirProjeto.append('contrato_id', openProjectData.contrato_id)
    formDataAbrirProjeto.append('proj_nome', openProjectData.contrato_nome)
    formDataAbrirProjeto.append('proj_cod', openProjectData.contrato_num)

    const resAbrirProjeto = await powerAppsApi.post('/', formDataAbrirProjeto, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.log('abrir_projeto', resAbrirProjeto)

    const formData = new FormData()
    formData.append('acao', 'cad_prod_rec')

    formData.append('proj_id', resAbrirProjeto.data)

    const res = await powerAppsApi.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })



    /*
    if (this.state.stakeholders.length > 0) {
      for (const stake of this.state.stakeholders) {

        if (stake.novo === 1) {
          console.log('novo', openProjectData);
          const newPfBody = {
            action: 'insert',
            table: 'pf',
            data: {
              pf_emailProf: stake.pf_emailProf,
              pf_nomeExibicao: stake.pf_nomeExibicao,
              pf_celProf: stake.pf_celProf,
              pf_cargo: stake.papel_nome,
              pj_id: openProjectData.contrato_contratante,
            }
          }

          const pfId = await oikosApi.post('/', newPfBody);

          console.log('pfId', pfId)

          const newStakeholderBody = {
            action: 'insert',
            table: 'projStake',
            data: {
              proj_id: resAbrirProjeto.data,
              pf_id: pfId.data[0].pf_id,
              papel_id: stake.papel_id
            }
          }

          await oikosApi.post('/', newStakeholderBody)


        } else {

          const newStakeholderBody = {
            action: 'insert',
            table: 'projStake',
            data: {
              proj_id: resAbrirProjeto.data,
              pf_id: stake.pf_id,
              papel_id: stake.papel_id,
            }
          }

          await oikosApi.post('/', newStakeholderBody)

        }

      }
    }
    */

    const updateContratoBody = {
      action: 'update',
      table: 'contrato',
      data: {
        contrato_id: openProjectData.contrato_id,
        contrato_projAbert: 1
      }
    }

    await oikosApi.post('/', updateContratoBody)

    if (openProjectData.contrato_original) {
      await update('proj', openProjectData.contrato_original, { proj_abert: 1 })
    } else {
      await update('proj', openProjectData.contrato_id, { proj_abert: 1 })
    }

    await powerAppsApi.post('/', {acao: 'importar_orcamento', proj_id: resAbrirProjeto.data}, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    this.setState({ openProjectModalIsOpen: false })
    this.componentDidMount()
  }

  getContratanteLabel = (id) => {
    const { legalPeople } = this.state

    const contratanteType = legalPeople?.find(p => p.pj_id === id)
    return (contratanteType?.pj_nomefanta || contratanteType?.pj_razaosocial)
  }

  fetchSelPfs = async () => {
    const { selectValues } = await import('../../../utils/fc');
    const resSelPfs = await selectValues('pf', 'pf_id', 'pf_nomeExibicao')
    console.log(resSelPfs.data);
    this.setState({ selPfs: resSelPfs });
  }

  ordenarPorLabel = (lista) => {
    return lista.sort((a, b) => {
      if (!a.label || !b.label) return 0;
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();

      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    });
  }

  handleOpenModalNovaPesquisa = async (proj_id) => {
    this.setState({ isModalOpenningLoading: true });
    const { selectValues } = await import('../../../utils/fc');

    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'perguntaFormulario',
      data: {
        tpFormulario_id: 1,
      },
    })}`);

    const resFormularioSecundario = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'tpFormulario',
      data: {
        tpFormulario_mae: 1,
      },
    })}`);

    this.fetchSelPfs();

    let perguntasFinal = [];

    if (res.data.length > 0 && typeof(res.data) !== 'string') {
      for (const [index, pergunta] of res.data.entries()) {
        if (pergunta.formatoCampo_id === 1 && pergunta.perguntaFormulario_tabRef) {
          const selOptions = await selectValues(pergunta.perguntaFormulario_tabRef, `${pergunta.perguntaFormulario_tabRef}_id`, pergunta.perguntaFormulario_selectLabel)
          const selOptionsSorted = this.ordenarPorLabel(selOptions);
          res.data[index].selOptions = selOptionsSorted;

          if (resFormularioSecundario.data.length > 0 && typeof(resFormularioSecundario.data) !== 'string') {
            perguntasFinal = res.data.map((perguntaPrincipal) => {
              for (let index = 0; index < resFormularioSecundario.data.length; index++) {
                const element1 = resFormularioSecundario.data[index];
                const perguntasQueTemFormularioSecundario = res.data.filter((pergunta) => {
                  return perguntaPrincipal.perguntaFormulario_id === pergunta.perguntaFormulario_id && pergunta.perguntaFormulario_id === element1.perguntaFormulario_id
                });
                if (perguntasQueTemFormularioSecundario.length > 0) {
                  for (let index = 0; index < perguntasQueTemFormularioSecundario.length; index++) {
                    const element2 = perguntasQueTemFormularioSecundario[index];
                    return {...perguntaPrincipal, formSecundario: [element2.formSecundario ? [...element2.formSecundario, element1] : [element1]]}
                  }
                } else {
                  return perguntaPrincipal;
                }
              }
            })
          }
        } else if (pergunta.formatoCampo_id === 1 && !pergunta.perguntaFormulario_tabRef && pergunta.perguntaFormulario_opcoes) {
          const obj = JSON.parse(pergunta.perguntaFormulario_opcoes);
          const arr = Object.entries(obj).map(([label, value]) => ({
            label,
            value
          })).sort((a, b) => a.value - b.value);;
          res.data[index].selOptions = arr;
        }
      }

      const perguntaProj = perguntasFinal.find(p => p.perguntaFormulario_id === 18);
      const labelProj = perguntaProj ? perguntaProj.perguntaFormulario_label : '1 - Projeto';

      this.setState({
        perguntas: perguntasFinal.sort((a, b) => a.perguntaFormulario_ord - b.perguntaFormulario_ord),
        isModalOpenningLoading: false,
        isOpenModalNovaPesquisa: true,
        defaultInputs: { [labelProj]: proj_id } // "Projeto" is the label of the proj_id selector (perguntaFormulario_id: 18)
      });
    } else {
      this.setState({ isModalOpenningLoading: false });
    }
  }

  render() {
    const { projects, listProjectsIsLoading, opProjects, listOpProjectsIsLoading } = this.props.technicalDep
    const {
      getLegalPeopleIsLoading, legalPeople,
      getProjectsToStartIsLoading, projectsToStart,
      openProjectModalIsOpen, openProjectIsLoading, openProjectData,
    } = this.state

    const { user } = this.props.auth;

    let ptBR = Intl.NumberFormat("pt-BR", {
      style: "decimal",
      currency: "BRL",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })
    //console.log('projects to open: ',opProjects)

    /*
                    <DataTable
                      className="table-clickable"
                      sortable={['proj_dtCria', 'desc']}
                      data={{
                        columns: [
                          {
                            label: 'Data assinatura',
                            field: 'contrato_dtAssin',
                          },
                          {
                            label: 'Contratante',
                            field: 'contrato_contratante',
                          },
                          {
                            label: 'Nome',
                            field: 'proj_nome',
                          },
                          {
                            label: 'Valor global',
                            field: 'contrato_vlrGlobal',
                          },
                          {
                            label: 'Prazo vigência',
                            field: 'contrato_prazoVigencia',
                          },
                        ],
                        rows: projects.filter(project => project.proj_situacao === 3).map(project => ({
                          contrato_dtAssin: moment(project.contrato_dtAssin).format('DD/MM/YYYY'),
                          contrato_num: project.contrato_num,
                          contrato_contratante: project.contrato_contratante,
                          proj_nome: project.proj_nome,
                          contrato_vlrGlobal: ptBR.format(project.contrato_vlrGlobal),
                          contrato_prazoVigencia: moment(project.contrato_prazoVigencia).format('DD/MM/YYYY'),
                          clickEvent: () => (
                            history.push({
                              pathname: `/dep-tecnico/projetos/${project.proj_id}`,
                              project,
                            })
                          ),
                        })),
                      }}
                    />
                    */

    const columnsOpProjects = [
      {
        accessorKey: 'proj_cod',
        header: 'Código',
        size: 100,
        sortingFn: 'normal',
      },
      {
        accessorKey: 'proj_nome',
        header: 'Nome',
        size: 100,
        sortingFn: 'normal',
      },
      {
        accessorKey: 'pj_nomefanta',
        header: 'Contratante',
        size: 300,
      },
      {
        accessorKey: 'contrato_vlrGlobal',
        header: 'Valor consolidado',
        accessorFn: (row) => currencyFormatter.format(row.contrato_vlrGlobal),
        size: 100,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          if (row.original.contrato_vlrGlobal) {
            return (cell.getValue())
          }
        }
      },
      {
        accessorKey: 'contratoInst_id',
        header: 'Tipo',
        accessorFn: (row) => {
          switch (row.contratoInst_id) {
            case 1:
              return "Contrato"
              return 6
            case 2:
              return "Aditamento"
              return 4
            case 4:
              return "Apostilamento"
              return 3
            case 3:
              return "Renovação"
              return 2
            case 5:
              return "Rescisão"
              return 5
          }
        },
        Cell: ({ cell, row }) => {
          switch (row.original.contratoInst_id) {
            case 2:
              return "Aditamento"
            case 3:
              return "Apostilamento"
            case 4:
              return "Renovação"
            case 5:
              return "Rescisão"
            case 1:
              return "Contrato"
          }
        },
        size: 50,
        filterSelectOptions: [
          'Contrato',
          'Rescisão',
          'Renovação',
          'Apostilamento',
          'Aditamento',
        ],
        filterVariant: 'multi-select'
      },
      {
        accessorKey: 'contrato_aguardarOS',
        header: 'Aguardar OS',
        size: 100,
        accessorFn: (row) => {
          if (row.contrato_aguardarOS === 1) { return 'Sim' } else { return 'Não' }
        },
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          return (cell.getValue())
        }
      },
      /*
      {
        accessorKey: 'uf_id',
        header: 'Estado',
        size: 100,
      },
      */
    ]

    const columnsProjects = [
      {
        accessorKey: 'contrato_dtAssin',
        header: 'Data assinatura',
        size: 30,
        accessorFn: (row) => {
          if (row.contrato_dtAssin) {
            return moment(row.contrato_dtAssin, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => {
          if (row.original.contrato_dtAssin) {
            return moment(cell.getValue()).format('DD/MM/YYYY')
          }
        }, // Format Date for display
      },
      {
        accessorKey: 'proj_nome',
        header: 'Nome',
        size: 300,
      },
      {
        accessorKey: 'pj_nomefanta',
        header: 'Contratante',
        size: 200,
        Cell: ({ cell, row }) => {
          if (row.original.pj_nomefanta) {
            return cell.getValue();
          }
          else {
            return 'Sem informação';
          }
        }, // Format Date for display
      },
      {
        accessorKey: 'contrato_vlrGlobal',
        header: 'Valor consolidado',
        accessorFn: (row) => row.contrato_vlrGlobal,
        size: 50,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          if (row.original.contrato_vlrGlobal) {
            return currencyFormatter.format(cell.getValue())
          }
        }
      },
      {
        accessorKey: 'proj_responsavelNome',
        header: 'Coordenador',
        size: 30,
        accessorFn: (row) => {
          if (row.proj_responsavelNome) {
            return row.proj_responsavelNome;
          } else {
            return null;
          }
        },
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          if (row.original.proj_responsavelNome) {
            return cell.getValue();
          }
        }, // Format Date for display
      },
      {
        accessorKey: 'contrato_prazoVigencia',
        header: 'Vigência consolidada',
        accessorFn: (row) => {
          if (row.contrato_prazoVigenciaAditivo) {
            return moment(row.contrato_prazoVigenciaAditivo, 'YYYY-MM-DD').toDate();
          }
          else if (row.contrato_prazoVigencia) {
            return moment(row.contrato_prazoVigencia, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        size: 30,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => {
          if (row.original.contrato_prazoVigenciaAditivo) {
            const today = new Date();
            const minusTenDays = moment(row.original.contrato_prazoVigenciaAditivo, 'YYYY-MM-DD').subtract(10, 'days').toDate();
            minusTenDays.setDate(moment(row.original.contrato_prazoVigenciaAditivo, 'YYYY-MM-DD').toDate().getDate() - 10);
            return <span style={{ color: today > minusTenDays ? "red" : "" }}>{moment(cell.getValue()).format('DD/MM/YYYY')}</span>;
          }
          else if (row.original.contrato_prazoVigencia) {
            const today = new Date();
            const minusTenDays = moment(row.original.contrato_prazoVigencia, 'YYYY-MM-DD').subtract(10, 'days').toDate();
            minusTenDays.setDate(moment(row.original.contrato_prazoVigencia, 'YYYY-MM-DD').toDate().getDate() - 10);
            return <span style={{ color: today > minusTenDays ? "red" : "" }}>{moment(cell.getValue()).format('DD/MM/YYYY')}</span>;
          }
        },
      },
    ]

    const columnsEncerramento = [
      {
        accessorKey: 'proj_nome',
        header: 'Nome do projeto',
        size: 300,
      },
      {
        accessorKey: 'contrato_prazoVigencia',
        header: 'Vigência consolidada',
        accessorFn: (row) => {
          if (row.contrato_prazoVigenciaAditivo) {
            return moment(row.contrato_prazoVigenciaAditivo, 'YYYY-MM-DD').toDate();
          }
          else if (row.contrato_prazoVigencia) {
            return moment(row.contrato_prazoVigencia, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        size: 30,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => {
          if (row.original.contrato_prazoVigenciaAditivo) {
            const today = new Date();
            const minusTenDays = moment(row.original.contrato_prazoVigenciaAditivo, 'YYYY-MM-DD').subtract(10, 'days').toDate();
            minusTenDays.setDate(moment(row.original.contrato_prazoVigenciaAditivo, 'YYYY-MM-DD').toDate().getDate() - 10);
            return <span style={{ color: today > minusTenDays ? "red" : "" }}>{moment(cell.getValue()).format('DD/MM/YYYY')}</span>;
          }
          else if (row.original.contrato_prazoVigencia) {
            const today = new Date();
            const minusTenDays = moment(row.original.contrato_prazoVigencia, 'YYYY-MM-DD').subtract(10, 'days').toDate();
            minusTenDays.setDate(moment(row.original.contrato_prazoVigencia, 'YYYY-MM-DD').toDate().getDate() - 10);
            return <span style={{ color: today > minusTenDays ? "red" : "" }}>{moment(cell.getValue()).format('DD/MM/YYYY')}</span>;
          }
        },
      },
      {
        accessorKey: 'produtosAprovados',
        header: 'Todos os produtos aprovados',
        size: 50,
        accessorFn: (row) => {
          if (Number(row.total_produtos || 0) === Number(row.total_produtos_aprovados || 0)) {
            return 'Sim';
          }
          return 'Não';
        },
        Cell: ({ cell, row }) => {
          if (Number(row.original.total_produtos || 0) === Number(row.original.total_produtos_aprovados || 0)) {
            return <span style={{ color: 'green', fontWeight: 'bold' }}>Sim</span>;
          }
          return <span style={{ color: 'red', fontWeight: 'bold' }}>Não ({row.original.total_produtos_aprovados || 0}/{row.original.total_produtos || 0})</span>;
        },
      },
      {
        accessorKey: 'eventosPagos',
        header: 'Todos os eventos pagos',
        size: 50,
        accessorFn: (row) => {
          if (Number(row.total_eventos || 0) === Number(row.total_eventos_pagos || 0)) {
            return 'Sim';
          }
          return 'Não';
        },
        Cell: ({ cell, row }) => {
          if (Number(row.original.total_eventos || 0) === Number(row.original.total_eventos_pagos || 0)) {
            return <span style={{ color: 'green', fontWeight: 'bold' }}>Sim</span>;
          }
          return <span style={{ color: 'red', fontWeight: 'bold' }}>Não ({row.original.total_eventos_pagos || 0}/{row.original.total_eventos || 0})</span>;
        },
      },
      {
        accessorKey: 'pesquisaRealizada',
        header: 'Pesquisa realizada',
        size: 50,
        accessorFn: (row) => row.tem_pesquisa > 0 ? 'Sim' : 'Não',
        Cell: ({ cell, row }) => {
          if (row.original.tem_pesquisa > 0) {
            return <span style={{ color: 'green', fontWeight: 'bold' }}>Sim</span>;
          }
          return (
            <div className="d-flex align-items-center">
              <span style={{ color: 'red', fontWeight: 'bold', marginRight: '10px' }}>Não</span>
              <Button
                size="sm"
                color="primary"
                style={{ fontSize: '10px', padding: '2px 5px', zIndex: 10 }}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  this.handleOpenModalNovaPesquisa(row.original.proj_id);
                }}
              >
                Responder
              </Button>
            </div>
          );
        },
      },
      {
        accessorKey: 'fornecedoresQuitados',
        header: 'Fornecedores quitados',
        size: 50,
        accessorFn: (row) => {
          const totalContratos = Number(row.total_forn_contratos || 0);
          const totalEventos = Number(row.total_forn_eventos || 0);
          const totalPagos = Number(row.total_forn_eventos_pagos || 0);
          if (totalContratos === 0) return 'Não possui fornecedores';
          if (totalContratos > 0 && totalEventos === 0) return 'Não';
          if (totalEventos > 0 && totalEventos === totalPagos) return 'Sim';
          return 'Não';
        },
        Cell: ({ cell, row }) => {
          const totalContratos = Number(row.original.total_forn_contratos || 0);
          const totalEventos = Number(row.original.total_forn_eventos || 0);
          const totalPagos = Number(row.original.total_forn_eventos_pagos || 0);
          if (totalContratos === 0) {
            return <span style={{ color: '#6c757d', fontWeight: 'bold' }}>Não possui fornecedores</span>;
          }
          if (totalContratos > 0 && totalEventos === 0) {
            return <span style={{ color: 'red', fontWeight: 'bold' }}>Não (sem eventos)</span>;
          }
          if (totalEventos > 0 && totalEventos === totalPagos) {
            return <span style={{ color: 'green', fontWeight: 'bold' }}>Sim</span>;
          }
          return <span style={{ color: 'red', fontWeight: 'bold' }}>Não ({totalPagos}/{totalEventos})</span>;
        },
      },
    ]

    return (
      <div className="page-content">
        <Modal
          size="lg"
          isOpen={openProjectModalIsOpen}
        >
          <ModalHeader toggle={() => {
            this.setState({ openProjectData: null, openProjectModalIsOpen: false })
          }
          }>
            {`Abrir Projeto - Proposta ${openProjectData?.contrato_num}`}
          </ModalHeader>
          <ModalBody>
            <Row style={{ marginTop: -12 }}>
              <Col>
                <Tabs forceRenderTabPanel>
                  <TabList>
                    <Tab>Geral</Tab>
                    {/*
                    <Tab>Stakeholders</Tab>
                    */}
                    {/*<Tab>Equipe</Tab>*/}
                  </TabList>

                  <TabPanel>
                    <Row>
                      <Col sm={6}>
                        <FormGroup>
                          <Label>
                            Contratante
                          </Label>
                          <Input
                            disabled
                            value={
                              openProjectData?.pj_nomefanta
                                ? openProjectData.pj_nomefanta
                                : null
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={6}>
                        <FormGroup>
                          <Label>
                            Valor global
                          </Label>
                          <Input
                            disabled
                            value={
                              openProjectData?.contrato_vlrGlobal
                                ? currencyFormatter.format(openProjectData.contrato_vlrGlobal)
                                : null
                            }
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={12}>
                        <FormGroup>
                          <Label>
                            Nome do projeto
                          </Label>
                          <Input
                            disabled={openProjectData?.contratoInst_id != 1}
                            value={openProjectData?.proj_nome}
                            onChange={e => this.setState({
                              openProjectData: {
                                ...openProjectData,
                                contrato_nome: e.target.value || null,
                                titleInputIsInvalid: false,
                              },
                            })}
                          />
                          <FormFeedback>
                            Campo obrigatório.
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                  </TabPanel>

                  {/*
                  <TabPanel>
                    <Row>
                      <Col sm={12}>
                        <Button
                          size="sm"
                          color="link"
                          className="mb-1 px-0"
                          onClick={() => {
                            this.setState(prev => ({...prev, stakeholders: [...this.state.stakeholders, {novo: 1}]}))
                          }}
                        >
                          Adicionar Stakeholder
                        </Button>
                      </Col>
                      {this.state.stakeholders.length > 0 &&
                        this.state.stakeholders.map((stake, index) => {
                          return (
                            <>
                              <Row>
                                <Col sm={12}>
                                  <FormGroup>
                                    <Label>
                                      Stakeholder
                                    </Label>

                                    <AsyncSelect
                                      cacheOptions
                                      defaultOptions
                                      isSearchable={true}
                                      isClearable={true}
                                      isMulti={false}
                                      getOptionValue={option => option.pf_id}
                                      getOptionLabel={option => option.pf_nomeExibicao}
                                      value={
                                        stake?.pf_id
                                          ? { pf_id: stake.pf_id, pf_nomeExibicao: stake.pf_nomeExibicao }
                                          : null
                                      }
                                      loadOptions={async (input) => {
                                        console.log(input)
                                        try {
                                          const res = await oikosApi.get('/', {
                                            action: 'get',
                                            table: 'pf',
                                          });
                                          return res.data;
                                        } catch (e) {
                                          return notifyError(e);
                                        }
                                      }}
                                      onChange={e => {
                                        const updatedStakeholders = [...this.state.stakeholders];
                                        if (!e) {
                                          updatedStakeholders[index] = { novo: 1 };
                                        } else {
                                          updatedStakeholders[index] = {
                                            ...updatedStakeholders[index],
                                            pf_id: e.pf_id,
                                            pf_nomeExibicao: e.pf_nomeExibicao,
                                            novo: 0,
                                          };
                                        }
                                        this.setState({ stakeholders: updatedStakeholders });
                                      }}
                                    />
                                    <FormFeedback>Campo obrigatório.</FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col sm={3}>
                                  <FormGroup>
                                    <Label>
                                      Nome
                                    </Label>
                                    <Input
                                      type="text"
                                      rows={2}
                                      value={stake.pf_nomeExibicao || ''}
                                      disabled={this.state.stakeholders[index]?.novo === 0}
                                      onChange={e => {
                                        const updatedStakeholders = [...this.state.stakeholders];
                                        updatedStakeholders[index] = {
                                          ...updatedStakeholders[index],
                                          pf_nomeExibicao: e.target.value
                                        };
                                        this.setState({ stakeholders: updatedStakeholders });
                                      }}
                                    />
                                    <FormFeedback>Campo obrigatório.</FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col sm={3}>
                                  <FormGroup>
                                    <Label>
                                      Email
                                    </Label>
                                    <Input
                                      type="text"
                                      rows={2}
                                      value={stake.pf_emailProf || ''}
                                      disabled={this.state.stakeholders[index]?.novo === 0}
                                      onChange={e => {
                                        const updatedStakeholders = [...this.state.stakeholders];
                                        updatedStakeholders[index] = {
                                          ...updatedStakeholders[index],
                                          pf_emailProf: e.target.value
                                        };
                                        this.setState({ stakeholders: updatedStakeholders });
                                      }}
                                    />
                                    <FormFeedback>Campo obrigatório.</FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col sm={3}>
                                  <FormGroup>
                                    <Label>
                                      Telefone
                                    </Label>
                                    <Input
                                      type="text"
                                      rows={2}
                                      value={stake.pf_celProf || ''}
                                      disabled={this.state.stakeholders[index]?.novo === 0}
                                      onChange={e => {
                                        const updatedStakeholders = [...this.state.stakeholders];
                                        updatedStakeholders[index] = {
                                          ...updatedStakeholders[index],
                                          pf_celProf: e.target.value
                                        };
                                        this.setState({ stakeholders: updatedStakeholders });
                                      }}
                                    />
                                    <FormFeedback>Campo obrigatório.</FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col sm={3}>
                                  <FormGroup>
                                    <Label>
                                      Cargo
                                    </Label>
                                    <AsyncSelect
                                      cacheOptions
                                      defaultOptions
                                      isSearchable={false}
                                      isClearable={false}
                                      isMulti={false}
                                      getOptionValue={option => option.papel_id}
                                      getOptionLabel={option => option.papel_nome}
                                      value={
                                        stake?.papel_id
                                          ? { papel_id: stake.papel_id, papel_nome: stake.papel_nome }
                                          : null
                                      }
                                      loadOptions={async () => {
                                        try {
                                          const res = await oikosApi.get('/', {
                                            action: 'get',
                                            table: 'papel',
                                          });
                                          return res.data;
                                        } catch (e) {
                                          return notifyError(e);
                                        }
                                      }}
                                      onChange={e => {
                                        const updatedStakeholders = [...this.state.stakeholders];
                                        updatedStakeholders[index] = {
                                          ...updatedStakeholders[index],
                                          papel_id: e.papel_id,
                                          papel_nome: e.papel_nome,
                                        };
                                        this.setState({ stakeholders: updatedStakeholders });
                                      }}
                                    />
                                    <FormFeedback>Campo obrigatório.</FormFeedback>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </>
                          )
                        })
                      }
                    </Row>

                  </TabPanel>
                  */}

                  <TabPanel>
                    <Row>
                      <Col>
                        <Label>
                          Cargo
                        </Label>
                      </Col>

                      <Col>
                        <Label>
                          Origem
                        </Label>
                      </Col>

                      <Col>
                        <Label>
                          Pessoa
                        </Label>
                      </Col>

                      <Col xs={1} />
                    </Row>

                    <Row>
                      <Col>
                        <Select
                          options={[
                            {
                              value: 'Coordenador geral',
                              label: 'Coordenador geral',
                            },
                            {
                              value: 'Coordenador meio físico',
                              label: 'Coordenador meio físico',
                            },
                            {
                              value: 'Coordenador meio biótico',
                              label: 'Coordenador meio biótico',
                            },
                            {
                              value: 'Coordenador meio socioeconômico',
                              label: 'Coordenador meio socioeconômico',
                            },
                          ]}
                        />
                      </Col>

                      <Col>
                        <Select
                          options={[
                            {
                              value: 'Colaborador',
                              label: 'Colaborador',
                            },
                            {
                              value: 'Consultor interno',
                              label: 'Consultor interno',
                            },
                            {
                              value: 'Consultor externo',
                              label: 'Consultor externo',
                            },
                            {
                              value: 'Contratar',
                              label: 'Contratar',
                            },
                          ]}
                        />
                      </Col>

                      <Col>
                        <Input
                          disabled
                        />
                      </Col>

                      <Col xs={1}>
                        <Button
                          color="light"
                          size="sm"
                        >
                          <i className="ri-add-fill font-size-18" />
                        </Button>
                      </Col>
                    </Row>
                  </TabPanel>
                </Tabs>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.setState({ openProjectData: {}, openProjectModalIsOpen: false })}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => this.handleOpenProjectSubmit()}
              disabled={!openProjectData || openProjectIsLoading || false}
            >
              Confirmar
              {openProjectIsLoading && (
                <Spinner size="sm" className="ml-2" />
              )}
            </Button>
          </ModalFooter>
        </Modal>

        <Container fluid>
          <Row className="mt-2">
            <Col>
              <h3 style={{ marginBottom: 0, paddingBottom: 0 }}>
                Projetos a iniciar
              </h3>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              {(listOpProjectsIsLoading || getLegalPeopleIsLoading) && (
                <div className="pb-3 d-flex align-items-center justify-content-center">
                  <Spinner size="sm" />
                </div>
              )}

              {!listOpProjectsIsLoading && !getLegalPeopleIsLoading && opProjects && legalPeople?.length > 0 && (
                <MaterialReactTable
                  columns={columnsOpProjects}
                  data={opProjects}
                  initialState={{
                    density: 'compact',
                    expanded: {}, //expand all groups by default
                    pagination: { pageIndex: 0, pageSize: 50 },
                    sorting: [{ id: 'pj_nomefanta', desc: true }],
                  }}
                  enableGrouping={false}
                  enableGlobalFilter={true}
                  enableFilters={true}
                  enablePagination={(opProjects.length > 50)}
                  muiTopToolbarProps={{
                    sx: {
                      '.MuiBox-root': { marginTop: "10px", height: "20px", display: "flex", alignItems: "center" },
                      '.MuiSvgIcon-root': { width: '12px' },
                      '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' },
                      '.MuiTablePagination-root .MuiToolbar-root': { minHeight: "30px !important", height: "30px !important" },
                      '.MuiTablePagination-root': { minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem" },
                    }
                  }}

                  muiTableBodyCellProps={{ sx: { fontSize: "13px", maxWidth: "100px" } }}
                  /*
                  */
                  muiTablePaginationProps={{
                    sx: { '.MuiTablePagination-displayedRows': { fontSize: "12px" }, fontSize: "12px" },
                    labelRowsPerPage: <span style={{ fontSize: "12px" }}>Projetos por página</span>,
                    rowsPerPageOptions: [50, 100],
                  }}
                  positionPagination='bottom'
                  muiTableHeadCellColumnActionsButtonProps={{ size: "8px" }}
                  enableRowExpansion={true}
                  enableDensityToggle={false}
                  enableColumnFilters={false}
                  muiTableHeadCellProps={{
                    sx: {
                      fontSize: '12px',
                      fontWeight: 'normal', // Remove bold text in the header
                      padding: '8px', // Adjust padding to reduce white space
                    },
                  }}

                  muiTableBodyRowProps={({ row }) => ({
                    onClick: () => {
                      const project = row.original

                      history.push({
                        pathname: `/dep-tecnico/projetos/${project.proj_id}`,
                        project,
                      })
                    },
                    sx: { cursor: 'pointer' },
                  })}


                //clicking anywhere on the row will select it
                /*
                */
                />
              )}
            </Col>
          </Row>

          <Row className="mt-2">
            <Col>
              <h3 style={{ marginBottom: 0, paddingBottom: 0 }}>
                Projetos
              </h3>
            </Col>
          </Row>
          {/*
          <Row>
              <Col className="mb-4" xl={4} lg={4} md={4} sm={4}>
                <Label>
                  Filtrar por Setor
                </Label>
                <Select
                  isMulti
                  placeholder="Setor"
                  defaultValue={[]}
                  options={[
                    {
                      value: 'Privado',
                      label: 'Privado',
                    },
                    {
                      value: 'Público',
                      label: 'Público',
                    },
                  ]}
                  onChange={options => this.setState({ clientTypeFilter: options })}
                />
              </Col>
              <Col className="mb-4" xl={4} lg={4} md={4} sm={4}>
                <Label>
                  Filtrar por Status
                </Label>
                <Select
                  isMulti
                  placeholder="Status"
                  options={[
                    {
                      value: 'Aguardando OIS',
                      label: 'Aguardando OIS',
                    },
                    {
                      value: 'Em andamento',
                      label: 'Em andamento',
                    },
                    {
                      value: 'Suspenso',
                      label: 'Suspenso',
                    },
                    {
                      value: 'Em conclusão',
                      label: 'Em conclusão',
                    },
                    {
                      value: 'Concluído',
                      label: 'Concluído',
                    },
                    {
                      value: 'Cancelado',
                      label: 'Cancelado',
                    },
                  ]}
                  onChange={status => this.setState({ statusFilter: status })}
                />
              </Col>
          </Row>
          */ }
          <Row className="mt-3">
            <Col>
              {listProjectsIsLoading && (
                <div className="pb-3 d-flex align-items-center justify-content-center">
                  <Spinner size="sm" />
                </div>
              )}

              {!listProjectsIsLoading && projects &&
                <Tabs forceRenderTabPanel>
                  <TabList>
                    <div className='d-flex justify-content-between align-items-center'>
                      <div>
                        <Tab>Em Andamento</Tab>
                        <Tab>Em Encerramento</Tab>
                        <Tab>Concluídos</Tab>
                      </div>
                      <div>
                        <Button
                          size="sm"
                          color="link"
                          className="ml-2 px-0"
                          onClick={(e) => {
                            e.preventDefault();
                            window.open("https://oikos.ecoss.is/oikos/webgis.php", "_blank", "noopener,noreferrer");
                          }}
                        >
                          Mapa
                        </Button>
                        <Button
                          size="sm"
                          color="link"
                          className="ml-2 px-0"
                          onClick={(e) => {
                            e.preventDefault();
                            window.open(`https://oikos.ecoss.is/oikos/_resumo_custos2.php?login123=${user.pf_emailProf}&pass123=${user.pf_senha}`, "_blank", "noopener,noreferrer");
                          }}
                        >
                          Custos dos projetos
                        </Button>
                      </div>
                    </div>
                  </TabList>
                  <TabPanel>
                    <MaterialReactTable
                      columns={columnsProjects}
                      data={projects.filter(proj => Number(proj.projSituacao_id) === 2)}
                      initialState={{
                        density: 'compact',
                        expanded: {},
                        pagination: { pageIndex: 0, pageSize: 50 },
                        sorting: [{ id: 'contrato_dtAssin', desc: true }],
                      }}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(projects.length > 50)}
                      muiTopToolbarProps={{
                        sx: {
                          '.MuiBox-root': { marginTop: "10px", height: "20px", display: "flex", alignItems: "center" },
                          '.MuiSvgIcon-root': { width: '12px' },
                          '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' },
                          '.MuiTablePagination-root .MuiToolbar-root': { minHeight: "30px !important", height: "30px !important" },
                          '.MuiTablePagination-root': { minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem" },
                        }
                      }}
                      muiTableBodyCellProps={{ sx: { fontSize: "13px", maxWidth: "100px" } }}
                      muiTablePaginationProps={{
                        sx: { '.MuiTablePagination-displayedRows': { fontSize: "12px" }, fontSize: "12px" },
                        labelRowsPerPage: <span style={{ fontSize: "12px" }}>Projetos por página</span>,
                        rowsPerPageOptions: [50, 100],
                      }}
                      positionPagination='top'
                      muiTableHeadCellColumnActionsButtonProps={{ size: "8px" }}
                      enableRowExpansion={true}
                      enableDensityToggle={false}
                      enableColumnFilters={false}
                      muiTableHeadCellProps={{
                        sx: {
                          fontSize: '12px',
                          fontWeight: 'normal',
                          padding: '8px',
                        },
                      }}
                      muiTableBodyRowProps={({ row }) => ({
                        onClick: () => {
                          const project = row.original
                          history.push({
                            pathname: `/dep-tecnico/projetos/${project.proj_id}`,
                            project,
                          })
                        },
                        sx: { cursor: 'pointer' },
                      })}
                    />
                  </TabPanel>
                  <TabPanel>
                    <MaterialReactTable
                      columns={columnsEncerramento}
                      data={projects.filter(proj => Number(proj.projSituacao_id) === 3)}
                      initialState={{
                        density: 'compact',
                        expanded: {},
                        pagination: { pageIndex: 0, pageSize: 50 },
                        sorting: [{ id: 'contrato_dtAssin', desc: true }],
                      }}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(projects.filter(proj => Number(proj.projSituacao_id) === 3).length > 50)}
                      muiTopToolbarProps={{
                        sx: {
                          '.MuiBox-root': { marginTop: "10px", height: "20px", display: "flex", alignItems: "center" },
                          '.MuiSvgIcon-root': { width: '12px' },
                          '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' },
                          '.MuiTablePagination-root .MuiToolbar-root': { minHeight: "30px !important", height: "30px !important" },
                          '.MuiTablePagination-root': { minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem" },
                        }
                      }}
                      muiTableBodyCellProps={{ sx: { fontSize: "13px", maxWidth: "100px" } }}
                      muiTablePaginationProps={{
                        sx: { '.MuiTablePagination-displayedRows': { fontSize: "12px" }, fontSize: "12px" },
                        labelRowsPerPage: <span style={{ fontSize: "12px" }}>Projetos por página</span>,
                        rowsPerPageOptions: [50, 100],
                      }}
                      positionPagination='top'
                      muiTableHeadCellColumnActionsButtonProps={{ size: "8px" }}
                      enableRowExpansion={true}
                      enableDensityToggle={false}
                      enableColumnFilters={false}
                      muiTableHeadCellProps={{
                        sx: {
                          fontSize: '12px',
                          fontWeight: 'normal',
                          padding: '8px',
                        },
                      }}
                      muiTableBodyRowProps={({ row }) => ({
                        onClick: () => {
                          const project = row.original
                          history.push({
                            pathname: `/dep-tecnico/projetos/${project.proj_id}`,
                            project,
                          })
                        },
                        sx: { cursor: 'pointer' },
                      })}
                    />
                  </TabPanel>
                  <TabPanel>
                    <MaterialReactTable
                      columns={columnsProjects}
                      data={projects.filter(proj => Number(proj.projSituacao_id) === 4)}
                      initialState={{
                        density: 'compact',
                        expanded: {},
                        pagination: { pageIndex: 0, pageSize: 50 },
                        sorting: [{ id: 'contrato_dtAssin', desc: true }],
                      }}
                      enableGrouping={false}
                      enableGlobalFilter={true}
                      enableFilters={true}
                      enablePagination={(projects.length > 50)}
                      muiTopToolbarProps={{
                        sx: {
                          '.MuiBox-root': { marginTop: "10px", height: "20px", display: "flex", alignItems: "center" },
                          '.MuiSvgIcon-root': { width: '12px' },
                          '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' },
                          '.MuiTablePagination-root .MuiToolbar-root': { minHeight: "30px !important", height: "30px !important" },
                          '.MuiTablePagination-root': { minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem" },
                        }
                      }}
                      muiTableBodyCellProps={{ sx: { fontSize: "13px", maxWidth: "100px" } }}
                      muiTablePaginationProps={{
                        sx: { '.MuiTablePagination-displayedRows': { fontSize: "12px" }, fontSize: "12px" },
                        labelRowsPerPage: <span style={{ fontSize: "12px" }}>Projetos por página</span>,
                        rowsPerPageOptions: [50, 100],
                      }}
                      positionPagination='top'
                      muiTableHeadCellColumnActionsButtonProps={{ size: "8px" }}
                      enableRowExpansion={true}
                      enableDensityToggle={false}
                      enableColumnFilters={false}
                      muiTableHeadCellProps={{
                        sx: {
                          fontSize: '12px',
                          fontWeight: 'normal',
                          padding: '8px',
                        },
                      }}
                      muiTableBodyRowProps={({ row }) => ({
                        onClick: () => {
                          const project = row.original
                          history.push({
                            pathname: `/dep-tecnico/projetos/${project.proj_id}`,
                            project,
                          })
                        },
                        sx: { cursor: 'pointer' },
                      })}
                    />
                  </TabPanel>
                </Tabs>
              }
            </Col>
          </Row>
        </Container>

        {this.state.selPfs &&
          <ModalFormulario
            title="Formulário de Pesquisa de Satisfação"
            openModal={this.state.isOpenModalNovaPesquisa}
            onClosed={() => this.setState({ isOpenModalNovaPesquisa: false })}
            data={this.state.perguntas}
            size='lg'
            selPfs={this.state.selPfs}
            fetchSelPfs={this.fetchSelPfs}
            defaultInputs={this.state.defaultInputs}
          />
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  technicalDep: state.technicalDep,
})
const mapDispatchToProps = dispatch => bindActionCreators({ listProjects, listOpProjects }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Projects)
